import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import '../styles/Unauthorized.css';

const Unauthorized: React.FC = () => {
  const { logout, user } = useAuth();
  const allowedDomain = process.env.REACT_APP_ALLOWED_COMPANY_DOMAIN;

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-card">
        <div className="unauthorized-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#EF4444" strokeWidth="2"/>
            <path d="M12 8V12M12 16H12.01" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <h1 className="unauthorized-title">Access Denied</h1>
        
        <div className="unauthorized-message">
          <p>Your email address <strong>{user?.email}</strong> is not authorized to access this application.</p>
          <p>Only email addresses from <strong>@{allowedDomain}</strong> domain are allowed.</p>
        </div>

        <div className="unauthorized-actions">
          <button onClick={logout} className="logout-button-unauthorized">
            Sign Out and Try Again
          </button>
          <p className="unauthorized-help">
            If you believe this is an error, please contact your system administrator.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;